export default __webpack_public_path__ + "static/media/emotionActive.cc473c39.png";